import * as React from 'react';
import { cn } from '../../lib/utils';

export interface StepIndicatorProps {
  readonly steps: readonly string[];
  readonly currentStep: number;
  readonly className?: string;
}

export function StepIndicator({
  steps,
  currentStep,
  className,
}: StepIndicatorProps): React.ReactElement {
  return (
    <div className={cn('w-full', className)} aria-label="progress">
      <ol className="flex items-center gap-2">
        {steps.map((step, index) => (
          <li
            key={step}
            className={cn(
              'flex-1 h-2 rounded-full transition-colors',
              index < currentStep && 'bg-primary',
              index === currentStep && 'bg-primary/70',
              index > currentStep && 'bg-muted',
            )}
            aria-current={index === currentStep ? 'step' : undefined}
          >
            <span className="sr-only">
              {index < currentStep
                ? `${step} (completed)`
                : index === currentStep
                  ? `${step} (current)`
                  : step}
            </span>
          </li>
        ))}
      </ol>
      <div className="mt-2 text-sm text-muted-foreground">
        <span className="font-medium">Step {currentStep + 1}</span> of {steps.length}:{' '}
        {steps[currentStep]}
      </div>
    </div>
  );
}
